'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _demographicsLocationTable = require('../demographics-location-table');

var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YoutubeDemographicsCountriesTable = function YoutubeDemographicsCountriesTable(_ref) {
  var data = _ref.audienceLocations.data;
  return _react2.default.createElement(_demographicsLocationTable2.default, { data: data, metric: 'views', itemLabel: 'Country' });
};

YoutubeDemographicsCountriesTable.propTypes = {
  audienceLocations: _propTypes2.default.object.isRequired
};

exports.default = YoutubeDemographicsCountriesTable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-demographics-countries-table/index.js
 ** module id = 967
 ** module chunks = 0
 **/